import { gql, useLazyQuery, type LazyQueryHookOptions } from "@apollo/client";

const PROPERTY_LISTINGS_QUERY = gql`
  query PropertyListings($filter: PropertyListingFilters) {
    propertyListings(filter: $filter) {
      id
      slug
      addressLine1
      unitNumber
      city
      province
      postalCode
      lease
      leasePerUnit
      leasePerTime
      price
      bathroomTotal
      bedroomsTotal
      images {
        id
        url
      }
    }
  }
`;

interface PropertyListingsVariables {
  filter: {
    listingAgentIds: string[];
  };
}

interface ListingImage {
  id: string;
  url: string | undefined;
}

interface PropertyListing {
  id: string;
  slug: string;
  addressLine1: string | undefined;
  unitNumber: string | undefined;
  city: string | undefined;
  province: string | undefined;
  postalCode: string | undefined;
  lease: string | undefined;
  leasePerUnit: string | undefined;
  leasePerTime: string | undefined;
  price: string | undefined;
  bathroomTotal: string | undefined;
  bedroomsTotal: string | undefined;
  images: ListingImage[];
}

interface PropertyListingsData {
  propertyListings: PropertyListing[];
}

const usePropertyListingsLazyQuery = (
  options?: LazyQueryHookOptions<PropertyListingsData, PropertyListingsVariables>,
) => {
  return useLazyQuery<PropertyListingsData, PropertyListingsVariables>(
    PROPERTY_LISTINGS_QUERY,
    options,
  );
};

export { usePropertyListingsLazyQuery };
export type { PropertyListingsData };
